import React from 'react'
import { Tabs, TabsProps } from '@material-ui/core'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'

interface YumLeaderboardTabsCompactProps extends Omit<TabsProps, 'onChange'> {
  classes: any
  children: React.ReactNode
  onChange: (event: React.ChangeEvent<{}>, value: any) => void
}

const YumLeaderboardTabsCompact = withStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
      '& .MuiTabScrollButton-root': {
        width: '32px',
        background: '#f2f2f6 !important',
        marginBottom: '1px',
        zIndex: '1',
        position: 'relative',
        //right: '-16px',
        '@media (max-width: 991px)': {
          '&:first-child': {
            right: '-16px',
          },
          '&:last-child': {
            left: '-16px',
          },
        },
        '@media (min-width: 992px)': {
          display: 'none',
        },
      },
      minHeight: '32px',
      borderRadius: '0px',
      //marginBottom: '16px',
      //backgroundColor: '#E3E3E8',
      /*[theme.breakpoints.up('md')]: {
        maxWidth: '400px',
        marginLeft: 'auto',
        marginRight: 'auto',
      },*/
      '@media (max-width: 991px)': {
        //marginLeft: '-16px',
        //marginRight: '-16px',
        marginLeft: '-32px',
        marginRight: '-32px',
        padding: '0 16px',
      },
      position: 'relative',
      '&:after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '1px',
        backgroundColor: '#C6C6CC',
        zIndex: -1,
      },
      marginBottom: '16px',
    },
    tabIndicator: {
      height: '1px',
      //borderRadius: '2px',
    },
  }),
)(({ children, classes, ...props }: YumLeaderboardTabsCompactProps) => {
  return (
    <Tabs
      //variant="fullWidth"
      // Use the scrollable variant so scroll buttons can appear when needed.
      variant="scrollable"
      scrollButtons="on"
      textColor="primary"
      indicatorColor="primary"
      classes={{
        root: classes.root,
        //flexContainer: classes.flexContainer,
      }}
      TabIndicatorProps={{
        className: classes.tabIndicator,
      }}
      {...props}
    >
      {children}
    </Tabs>
  )
})

export default YumLeaderboardTabsCompact
